import { render } from "./Main.vue?vue&type=template&id=f2089caa&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=f2089caa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f2089caa"

export default script